// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5d7fd3d7","84":"e8f81318","407":"7ff37732","410":"87cea65b","459":"418df2db","813":"3fe7d1a9"}[chunkId] + ".chunk.js";
};